const choices = {
    loan: 'Crédit',
    other: 'Autre',
};

export default choices;
